import { SubOrder, SuborderTrackingUpdateRequest } from "../../models/suborder";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import SubmitButton from "../genericButtons/submitButton/SubmitButton";
import agent from "../../api/agent";
import { error } from "console";

interface Props {
  closeHandler: (refresh?: boolean) => void;
  subOrder: SubOrder;
}

export default function SubOrderTrackingForm({
  closeHandler,
  subOrder,
}: Props) {
  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors, isValid },
  } = useForm<SuborderTrackingUpdateRequest>({
    mode: "all",
    defaultValues: { ups_unique: subOrder?.ups_unique },
  });

  // Submit form
  async function submitForm(values: SuborderTrackingUpdateRequest) {
    try {
      await toast.promise(
        agent.SubOrders.updateUpsUnique(subOrder.id, values),
        {
          pending: "Updating suborder ups unique code",
          success: "Update succeeded",
          error: "Something went wrong",
        },
      );
      try {
        const response = await agent.Transmart.referenceCheck(
          values.ups_unique,
        );
        toast.success(`${response.message}`);
      } catch (error: any) {
        toast.error(`Unique Reference: ${error.response.data.message}`);
      }
    } catch (error: any) {
      toast.error(`${error.response.data.message}`);
    } finally {
      closeHandler(true);
    }
  }

  //#region RENDER
  return (
    <form onSubmit={handleSubmit(submitForm)}>
      <div className="space-y-12">
        <div className="pb-12">
          {/* Header */}
          <h2 className="text-base font-semibold leading-7 text-gray-900">
            Update UPS unique field
          </h2>

          {/* Form body */}
          <div className="mt-10">
            {/* ups_unique */}
            <fieldset className="sm:col-span-3">
              <label
                htmlFor="ups_unique"
                className={
                  errors.ups_unique
                    ? "block text-sm font-medium leading-6 text-red-900"
                    : "block text-sm font-medium leading-6 text-gray-900"
                }
              >
                {errors.ups_unique ? errors?.ups_unique?.message : "Ups unique"}
              </label>
              <div className="relative mt-2">
                <input
                  placeholder="e.g. 301122SEP-R0001-IREOUT"
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-amber-600 sm:text-sm sm:leading-6"
                  type="text"
                  id="code"
                  {...register("ups_unique", {
                    required: "The ups unique is required",
                    pattern: {
                      value:
                        /^[0-9]{6}[a-zA-Z0-9]{3}-R[0-9]{4}-[a-zA-Z0-9]{2,6}$/,
                      message:
                        "Invalid format. This must be of a specific format: 000000XXX-R0000-XXYYYY (Y are optional). Example: 301122SEP-R0001-IREOUT",
                    },
                  })}
                />
              </div>
            </fieldset>
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="mt-6 flex items-center justify-end gap-x-6">
        <button
          onClick={() => closeHandler(false)}
          type="button"
          className="text-sm font-semibold leading-6 text-gray-900"
        >
          Cancel
        </button>

        <SubmitButton conditionals={[isValid]} isSubmitting={isSubmitting} />
      </div>
    </form>
  );
  //#endregion
}
